import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";

const FORM_STYLE = { minWidth: "15%", maxWidth: "15%" };
const ALL_ITEMS = "all";

export const AnalyticsItemSelector = ({ companyList, onEntityChange }) => {
  const [optionList, setOptionList] = useState({
    companies: [],
    advertisers: [],
    projects: [],
    items: [],
  });
  const [selectedValue, setSelectedValue] = useState({
    company: "none",
    advertiser: "none",
    project: "none",
    item: [ALL_ITEMS],
  });

  useEffect(() => {
    setOptionList((old) => ({
      ...old,
      companies: companyList.map((c) => ({ id: c.company_id, name: c.name })),
    }));
  }, [companyList]);

  const handleCompanyChange = (e) => {
    const selectedCompany = e.target.value;
    setSelectedValue(() => ({
      company: selectedCompany,
      advertiser: "none",
      project: "none",
      item: [ALL_ITEMS],
    }));

    setOptionList((old) =>
      selectedCompany !== "none"
        ? {
            ...old,
            advertisers: companyList
              .find((c) => c.company_id === selectedCompany)
              .advertisers.map((a) => ({ id: a.advertiser_id, name: a.name })),
          }
        : {
            ...old,
            advertisers: [],
            projects: [],
            items: [],
          }
    );
    onEntityChange(null);
  };
  const handleAdvertiserChange = (e) => {
    const selectedAdvertiser = e.target.value;
    setSelectedValue((old) => ({
      ...old,
      advertiser: selectedAdvertiser,
      project: "none",
      item: [ALL_ITEMS],
    }));

    setOptionList((old) =>
      selectedAdvertiser !== "none"
        ? {
            ...old,
            projects: companyList
              .find((c) => c.company_id === selectedValue.company)
              .advertisers.find((a) => a.advertiser_id === selectedAdvertiser)
              .projects.map((p) => ({ id: p.project_id, name: p.name })),
          }
        : {
            ...old,
            projects: [],
            items: [],
          }
    );
    onEntityChange(null);
  };
  const handleProjectChange = (e) => {
    const selectedProject = e.target.value;
    setSelectedValue((old) => ({
      ...old,
      project: selectedProject,
      item: [ALL_ITEMS],
    }));

    if (selectedProject !== "none") {
      const itemList = companyList
        .find((c) => c.company_id === selectedValue.company)
        .advertisers.find((a) => a.advertiser_id === selectedValue.advertiser)
        .projects.find((p) => p.project_id === selectedProject)
        .items.map((i) => ({
          id: i.item_data.item_id,
          name: i.item_data.name,
        }));
      setOptionList((old) => ({
        ...old,
        items: itemList,
      }));
      onEntityChange({
        advertiserId: selectedValue.advertiser,
        projectId: selectedProject,
        itemList: itemList.map((i) => i.id),
      });
    } else {
      setOptionList((old) => ({
        ...old,
        items: [],
      }));
      onEntityChange(null);
    }
  };
  const handleItemChange = (e) => {
    let selectedItem = e.target.value;
    const diffItem = selectedItem.find(
      (item) => !selectedValue.item.includes(item)
    );

    if (selectedItem.length > selectedValue.item.length) {
      if (diffItem === ALL_ITEMS) {
        selectedItem = [ALL_ITEMS];
      } else {
        selectedItem = selectedItem.filter((item) => item !== ALL_ITEMS);
      }
    } else {
      if (selectedItem.length === 0) {
        selectedItem = [ALL_ITEMS];
      }
    }

    setSelectedValue((old) => ({
      ...old,
      item: selectedItem,
    }));

    if (selectedItem.includes(ALL_ITEMS)) {
      const itemList = companyList
        .find((c) => c.company_id === selectedValue.company)
        .advertisers.find((a) => a.advertiser_id === selectedValue.advertiser)
        .projects.find((p) => p.project_id === selectedValue.project)
        .items.map((i) => ({
          id: i.item_data.item_id,
          name: i.item_data.name,
        }));
      onEntityChange({
        advertiserId: selectedValue.advertiser,
        projectId: selectedValue.project,
        itemList: itemList.map((i) => i.id),
      });
    } else {
      onEntityChange({
        advertiserId: selectedValue.advertiser,
        projectId: selectedValue.project,
        itemList: selectedItem,
      });
    }
  };

  return (
    <Box
      style={{ display: "flex", gap: "1rem", alignItems: "center" }}
      component="div"
    >
      <FormControl sx={FORM_STYLE} size="small">
        <InputLabel id="company-label">Company</InputLabel>
        <Select
          labelId="company-label"
          id="company-select"
          value={selectedValue.company}
          onChange={handleCompanyChange}
          label="Company"
        >
          <MenuItem value="none">
            <em>-</em>
          </MenuItem>
          {optionList.companies.map((c) => (
            <MenuItem key={c.id} value={c.id}>
              {c.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {optionList.advertisers.length > 0 ? (
        <FormControl sx={FORM_STYLE} size="small">
          <InputLabel id="advertiser-label">Advertiser</InputLabel>
          <Select
            labelId="advertiser-label"
            id="advertiser-select"
            value={selectedValue.advertiser}
            onChange={handleAdvertiserChange}
            label="Advertiser"
          >
            <MenuItem value="none">
              <em>-</em>
            </MenuItem>
            {optionList.advertisers.map((c) => (
              <MenuItem key={c.id} value={c.id}>
                {c.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <></>
      )}

      {optionList.projects.length > 0 ? (
        <FormControl sx={FORM_STYLE} size="small">
          <InputLabel id="project-label">Project</InputLabel>
          <Select
            labelId="project-label"
            id="project-select"
            value={selectedValue.project}
            onChange={handleProjectChange}
            label="Project"
          >
            <MenuItem value="none">
              <em>-</em>
            </MenuItem>
            {optionList.projects.map((c) => (
              <MenuItem key={c.id} value={c.id}>
                {c.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <></>
      )}

      {optionList.items.length > 0 ? (
        <FormControl sx={FORM_STYLE} size="small">
          <InputLabel id="item-label">Item</InputLabel>
          <Select
            labelId="item-label"
            id="item-select"
            value={selectedValue.item}
            onChange={handleItemChange}
            label="Item"
            multiple={true}
          >
            <MenuItem value={ALL_ITEMS}>*</MenuItem>
            {optionList.items.map((c) => (
              <MenuItem key={c.id} value={c.id}>
                {c.name.slice(0, 40)}
                {c.name.length > 40 ? "..." : ""}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <></>
      )}
    </Box>
  );
};
